/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmDeployContractInfo = {
    ADDR: string;
    CNM: string;
    CMP: string;
    CMPVER: string;
    BL: string;
    TRXCNT: string;
    OPT: EvmDeployContractInfo.OPT;
    DPLUT: number;
};

export namespace EvmDeployContractInfo {

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

